import MaterialTable from 'material-table'
import React, { useContext, useEffect, useState } from 'react'
import tableIcons, { options } from 'components/universal/table_attributes'
import {
    Typography,
    Paper,
    IconButton,
    Menu,
    MenuItem, Box,
    TextField
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { format24HrDateOnly, getColors, getOrganisationId } from 'lib/utils/common_utils';
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'
import RedCrossIcon from 'assets/Red remove icon.png'
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import MROTextField from 'components/form_components/TextField';
import Receipt from 'views/Commercial/Parts/CoreExchange/SharedComponents/Receipt';
import TraceDocuments from 'views/Commercial/Parts/CoreExchange/SharedComponents/TraceDocuments';
import { ToastMessageContext } from 'lib/contexts/message_context';



export default function SelectedCoreDetails(props) {

    const { currentSelection, setCoreValues, action, setAction, setConfirmationPopup, permission } = props
    const [data, setData] = useState([])
    const [traceData, setTraceData] = useState([])
    const [loading, setLoading] = useState(null)
    const [editingRowId, setIsEditRowId] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const [isEditable, setIsEditable] = useState(false)
    const message = useContext(ToastMessageContext)
    const fetchData = async () => {
        if (!currentSelection?.id) return;

        setLoading(true);
        const receiptParams = {
            organisation_id: getOrganisationId(),
            id: currentSelection.id,
        };
        const traceParams = {
            organisation_id: getOrganisationId(),
            sales_order_core_id: currentSelection.id,
        };

        try {
            const [receiptRes, traceRes] = await Promise.all([
                PartSalesServices.getReceiptDetails(receiptParams),
                PartSalesServices.getSubTraceDetails(traceParams)
            ]);

            const receiptData = [receiptRes] || [];
            const traceData = traceRes?.data || [];

            setData(receiptData);
            setTraceData(traceData)

            // Or use a custom merge
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (traceData.length > 0) {


            const total_value = traceData.reduce((acc, row) => {
                const value = parseFloat(row.trace_fee ?? 0);
                return acc + (isNaN(value) ? 0 : value);
            }, 0);
            setCoreValues((ps) => ({ ...ps, traceFees: total_value.toFixed(2) }))
        }
    }, [traceData])



    useEffect(() => {
        if (currentSelection?.id !== undefined) {
            fetchData();
        }
    }, [])


    const renderStateIcon = (rowData) => {

        const Icon = {
            0: <CommercialIcon fill={getColors("amber")} />,
            1: <TickIcon fill={getColors("green")} />,
            2: <img src={RedCrossIcon} height={'20px'} />,


        }

        return Icon[rowData?.status]

    }





    const handleMenuOpen = (event, rowData) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(rowData);
        setIsEditRowId(rowData?.id)
    };

    const handleEditTraceFee = (rowData) => {
        setIsEditable(true)

        handleMenuClose();

    };

    // Handle Menu Close
    const handleMenuClose = () => {
        setAnchorEl(null);
        // setSelectedRow(null);
    };

    const handleViewDocuments = () => {
        setAction("trace_document")
        handleMenuClose();
    };


    const handleUpdateTraceDetails = (id, name, newData) => {
        const formData = new FormData()

        formData.append("organisation_id", getOrganisationId())

        formData.append("id", name === "edit" ? id : selectedRow?.id)
        if (name === "edit") {
            formData.append("edit_trace_fee", "yes")
            formData.append("penalty_fee", newData?.trace_fee)
        } if (name === "received") {
            handleMenuClose();
            formData.append("mark_recived", "yes")

        } if (name === "not_received") {
            handleMenuClose();
            formData.append("mark_not_recived", "yes")

        }

        PartSalesServices.updateSubCoreTraceItem(formData).then((res) => {
            message.showToastMessage({
                message: "Trace Updated successfully.",
                variant: "success",
            });
            fetchData()

            setIsEditable(false)
        }).catch((res) => {
            setIsEditable(false)
            message.showToastMessage({ message: res.errors ? res.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
        })


    };




    const receiptColumns = [

        {
            title: "Receipt",
            field: "recept",
            cellStyle: {
                textAlign: "left",
                width: "45%",
                paddingLeft: "20px"

            },
            headerStyle: {
                textAlign: "left",
                width: "45%",
                paddingLeft: "20px"
            }
        },
        {
            title: "Due",
            field: "due",
            render: (rowData) => format24HrDateOnly(rowData?.due)
        },
        {
            title: "Received",
            field: "received",
            render: (rowData) => format24HrDateOnly(rowData?.received)
        },
        {
            title: "Late Days",
            field: "late_day"
        },
        {
            title: "Day Fee",
            field: "day_fee",
        },
        {
            title: "Late Fee",
            field: "late_fee",
        },
        {
            title: "Currency",
            field: "currency"
        },
        {
            title: "Action",
            field: "",
            render: (rowData) => <IconButton onClick={() => {
                setConfirmationPopup(false)
                setAction("repair")
                setSelectedRow(rowData)
            }}>
                <EditIcon fontSize='small' htmlColor={ICON_COLOUR} />
            </IconButton>
        }
    ]
    const handleCancel = () => {
        setIsEditRowId(null);
    };
    const traceColumns = [
        {
            title: "Code",
            field: "code",
            editable: "never",
            cellStyle: {
                textAlign: "left",

                paddingLeft: "20px"

            },
            headerStyle: {
                textAlign: "left",

                paddingLeft: "20px"
            }
        },
        {
            title: "Trace Requirement",
            field: "name",
            editable: "never",
            cellStyle: {
                textAlign: "left",
                width: "40%"

            },
            headerStyle: {
                textAlign: "left",
                width: "40%"
            }
        },
        {
            title: "Percentage",
            field: "percent",
            editable: "never",
            render: (rowData) => `${rowData.percent}%`
        },
        {
            title: "Value",
            field: "value",
            editable: "never",
        },
        {
            title: "Status",
            field: "status",
            editable: "never",
            render: (rowData) => renderStateIcon(rowData)

        },
        {
            title: "Trace Fee",
            field: "trace_fee",


        },
        {
            title: "Currency",
            field: "currency",
            editable: "never",
        },
        {
            title: "Action",
            field: "action",
            editable: "never",
            render: (rowData) =>

                <>
                    <IconButton onClick={(e) => {
                        handleMenuOpen(e, rowData)
                        setSelectedRow(rowData)

                    }}>
                        <MoreVertIcon />
                    </IconButton>

                    {anchorEl &&
                        <Menu id={`long-menu`}
                            anchorEl={anchorEl}
                            // keepMounted
                            open={Boolean(anchorEl)}
                            // className={classes.menu}
                            onClose={handleMenuClose}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ horizontal: "left" }}
                            PaperProps={{
                                style: {
                                    maxHeight: 45 * 4,
                                    width: "25ch",
                                    fontStyle: "13px"
                                },
                            }} >
                            <MenuItem onClick={handleViewDocuments}>Documents</MenuItem>

                            <MenuItem onClick={() => handleEditTraceFee(rowData)}>Edit Trace Fee</MenuItem>


                            <MenuItem onClick={() => handleUpdateTraceDetails(rowData?.id, "received")}>
                                Mark Received
                            </MenuItem>


                            <MenuItem onClick={() => handleUpdateTraceDetails(rowData?.id, "not_received")}>
                                Mark NOT Received
                            </MenuItem>

                        </Menu>}
                </>

        },
    ];



    let tableOptions = {

        ...options,
        search: false,
        paging: false,
        toolbar: false,

    }

    const tableConfigurations = [
        { data: data, columns: receiptColumns, name: "receipt" },
        {
            data: traceData, columns: traceColumns, name: "trace", editable: isEditable && {
                isEditHidden: (rowData) => rowData?.id !== editingRowId,
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {
                        handleUpdateTraceDetails(newData?.id, "edit", newData)
                        resolve();
                    }),
            },
        },
    ];



    return (
        <Box mt={"10px"}>


            {tableConfigurations.map((config, index,) => (
                <div key={index}>
                    <MaterialTable
                        title=""
                        icons={tableIcons}
                        columns={
                            config.name === "trace" && isEditable
                                ? config.columns.filter((col) => col.field !== "action")
                                : config.columns
                        }
                        data={config.data}
                        options={tableOptions}

                        editable={config.editable}
                    />
                    {/* Spacing */}
                    <Box mb={2} />
                </div>
            ))}
            {action && action === "repair" && <Receipt handleClose={() => {
                setConfirmationPopup(false)
                setAction(null)
                fetchData()
            }}
                id={currentSelection.id} currentSelection={selectedRow} setCoreValues={setCoreValues} tab={"commercial"}
            />}
            {action && action === "trace_document" && <TraceDocuments handleClose={() => {
                setConfirmationPopup(false)
                setAction(null)
                fetchData()
            }}
                id={currentSelection.id} currentSelection={selectedRow} open={true}
                writePermission={permission?.write}
            />}
        </Box>
    )
}

